import { useState, useEffect } from 'react';

export const useIntersection = (
    element: HTMLElement | null,
    rootMargin: string
): boolean => {
    const [isVisible, setState] = useState<boolean>(false);
    useEffect(() => {
        if (element) {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    setState(entry.isIntersecting);
                },
                { rootMargin }
            );

            element && observer.observe(element);

            return () => observer.unobserve(element);
        }
    }, [element]);

    return isVisible;
};
